import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from "../../../environments/environment";
import { GenericUser } from "../../_models";
import { DataService } from "../../_services/data.service";
import { AuthenticationService } from "../../_services/authentication.service";

@Component({
  selector: "app-header",
  templateUrl: "app-header.component.html",
  styleUrls: ["app-header.component.scss"],
})
export class AppHeaderComponent {
  public _currentUser: GenericUser;
  public messages: any;
  public siteId: string;
  @Output("logoutUser") logoutUser: EventEmitter<void> =
    new EventEmitter<void>();
  public isCollapsed: boolean = true;
  private environment: {
    features: {
      brothersAttributionPage: boolean;
      ModalWithBrotherAttributionAfterChildSave: boolean;
      collectiveRefund: boolean;
      ForgotPasswordSendEmail: boolean;
      CollectiveRefundSecondApproval: boolean;
      ShowGetPaymentsSummary: boolean;
    };
    enableProdMode: boolean;
    name: string;
    showHeaderVideo: boolean;
    BACKEND_API_URL: string;
  };

  constructor(
    private dataService: DataService,
    private authenticationService: AuthenticationService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
    this.authenticationService.siteId.subscribe((nextVal) => {
      this.siteId = nextVal;
    });
    this.environment = environment;
  }

  @Input("currentUser") public set setCurrentUser(value: any) {
    this._currentUser = value as GenericUser;
  }
  public menuClicked() {
    this.isCollapsed = !this.isCollapsed;
  }

  public logout() {
    this.logoutUser.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/header/app-header/app-header.component.ts